import { useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import scholarship1 from '../assets/banner1.png';
import scholarship2 from '../assets/banner2.png';
import scholarship3 from '../assets/banner3.png';
import scholarship4 from '../assets/banner4.png';
import scholarship5 from '../assets/banner6.png';
import scholarship6 from '../assets/banner9.png';
import scholarship8 from '../assets/banner11.png';
import scholarship9 from '../assets/banner12.png';
import scholarship7 from '../assets/banner10.png';
import scholarship11 from '../assets/banner16.png';
import scholarship10 from '../assets/banner13.png';
import scholarship12 from '../assets/banner19.png';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SchoolIcon from '@mui/icons-material/School';
import StarIcon from '@mui/icons-material/Star';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AutoPopUp from './AutoPopUp';
import image from "../assets/mainbanner1.png";

const RepeaterMedical = () => {
    const [openPopup, setOpenPopup] = useState(false);

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    const pointsData = [
        "Separate Hostel Facility for Boys & Girls.",
        "Expert Faculty, Study-Focused Environment.",
        "Complete Study Material Package.",
        "Daily Practice Questions & Assignments.",
        "Advanced Test Series & Analysis.",
    ];
    return (
        <Box sx={{ bgcolor: '#f8f9fa', py: 8, mt: 10 }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 700,
                            color: '#1a237e',
                            mb: 2,
                            fontSize: { xs: '2rem', md: '3rem' }
                        }}
                    >
                        🎯 NEET Repeater Admissions 2026 Now LIVE at Aakash Yelahanka
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#555',
                            maxWidth: '800px',
                            mx: 'auto',
                            lineHeight: 1.8
                        }}
                    >
                        Aakash Yelahanka proudly announces that admissions for the NEET Repeater Batch 2026 are now open. This is your chance to prepare under India's most trusted coaching ecosystem and move one step closer to your dream MBBS seat.
                    </Typography>
                </Box>

                <Grid container spacing={4} sx={{ mb: 6 }}>
                    {[image].map((item, index) => (
                        <Grid item xs={12} md={12}>
                            <Box
                                component="img"
                                src={item}
                                alt="Aakash Yelahanka"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: 3,
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={4} sx={{ mb: 6 }}>
                    {[scholarship6, scholarship7, scholarship11, scholarship12].map((item, index) => (
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src={item}
                                alt="Aakash Yelahanka"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: 3,
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Box
                    sx={{
                        bgcolor: '#e3f2fd',
                        borderRadius: 3,
                        p: 5,
                        mb: 6,
                        textAlign: 'center',
                        border: '2px solid #2196f3'
                    }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a237e', mb: 3 }}>
                        Why Choose Aakash Yelahanka?
                    </Typography>
                    {pointsData.map((item1, index) => (
                        <Typography key={index} variant="h6" sx={{ color: '#555', lineHeight: 1.8, fontStyle: 'italic', textAlign: 'left' }}>
                            ✓ {item1}
                        </Typography>
                    ))}
                    <Typography variant="body1" sx={{ color: '#666', mt: 4 }}>
                        Limited Period Offer – Join Now and Secure Your Future! Don't miss this golden opportunity to transform your NEET preparation and achieve your medical career goals.
                    </Typography>
                </Box>

                <Box
                    sx={{
                        bgcolor: 'white',
                        borderRadius: 3,
                        p: { xs: 3, md: 5 },
                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#1a237e', mb: 2 }}>
                        Ready to Begin Your Journey?
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                        Take the first step towards your dream career. Apply now for the Aakash Yelahanka.
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            bgcolor: '#ff6b35',
                            px: 6,
                            py: 2,
                            fontSize: '1.2rem',
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: '#e55a2b',
                                transform: 'scale(1.05)'
                            },
                            transition: 'all 0.3s ease'
                        }}
                        onClick={() => setOpenPopup(true)}
                    >
                        Apply Now
                    </Button>
                </Box>
            </Container>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </Box>
    );
};

export default RepeaterMedical;